import { Component, OnInit } from "@angular/core";

@Component({
    selector: "ngx-info",
    template: `<ngx-one-column-layout>
        <router-outlet></router-outlet>
    </ngx-one-column-layout>`,
    styleUrls: ["./info.component.scss"],
})
export class InfoLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
